export const buttonClickHandler = (onInvokeAction) => {
    return async (option, requestAttributes={}) => {
        if (requestAttributes.actionType === 'web_url') {
            await onInvokeAction(`${requestAttributes.payload || requestAttributes.url}`, requestAttributes);
            window.open(requestAttributes.url, '_blank');
        } else if (requestAttributes.actionType === 'go_to_step') {
            await onInvokeAction(`${requestAttributes.title}`, requestAttributes);
        } else if (requestAttributes.actionType === 'set_input') {
            await onInvokeAction(`${requestAttributes.inputValue}`, requestAttributes);
        } else {
            await onInvokeAction(option, requestAttributes);
        }
    }
}
